import { render, staticRenderFns } from "./Unsubmit.vue?vue&type=template&id=1205ae74"
import script from "./Unsubmit.vue?vue&type=script&lang=js"
export * from "./Unsubmit.vue?vue&type=script&lang=js"
import style0 from "./Unsubmit.vue?vue&type=style&index=0&id=1205ae74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports